import React, { useRef } from 'react';
import { useWebSocket } from '../hooks/useWebSocket';
import ConnectionStatus from './ConnectionStatus';
import MessageList from './MessageList';
import MessageInput from './MessageInput';

const ChatRoom = ({ roomId, requestedUsername }) => {
  const messagesContainerRef = useRef(null);
  
  const { 
    messages, 
    isConnected, 
    uniqueUsername, 
    sendMessage
  } = useWebSocket(roomId, requestedUsername);  

  return (
    <>
      <ConnectionStatus 
        isConnected={isConnected} 
        uniqueUsername={uniqueUsername} 
      />
      
      <MessageList 
        messages={messages} 
        forwardedRef={messagesContainerRef}
      />
      
      <MessageInput 
        isConnected={isConnected} 
        onSendMessage={sendMessage}
        messagesContainerRef={messagesContainerRef}
      />
    </>
  );
};

export default ChatRoom;